


















import {Component, Prop, Vue} from 'vue-property-decorator';
import {imageGallery} from "../../shared/helpers/image-gallery";

@Component({
  name: 'search-autocomplete-list-item'
})

export default class extends Vue {
  @Prop({required: true}) private readonly product: object;

  private get productImage(): string {
    return imageGallery.getSingleImage(this.product, '60x60');
  }
}
